import BootTrainers from '@/containers/course/BootTrainers';
import BootTrainer from '@/containers/course/BootTrainer';
import Create from '@/containers/course/Create';
import Weekdays from '@/containers/course/Weekdays';
import Programs from '@/containers/course/Programs';
import BulkingOptions from '@/containers/course/BulkingOptions';
import View from '@/containers/course/View';
import Editing from '@/containers/course/Editing';
import Deleting from '@/containers/course/Deleting';
import Notification from '@/containers/course/Notification';

import {
    ROUTE_COURSE_BOOT_TRAINERS,
    ROUTE_COURSE_BOOT_TRAINER,
    ROUTE_COURSE_CREATE,
    ROUTE_COURSE_CREATE_WEEKDAYS,
    ROUTE_COURSE_CREATE_PROGRAMS,
    ROUTE_COURSE_CREATE_BULKING_OPTIONS,
    ROUTE_COURSE_VIEW,
    ROUTE_COURSE_VIEW_WEEKDAYS,
    ROUTE_COURSE_VIEW_PROGRAMS,
    ROUTE_COURSE_VIEW_BULKING_OPTIONS,
    ROUTE_PERIODIC_COURSE_EDITING,
    ROUTE_PERIODIC_COURSE_DELETING,
    ROUTE_COURSE_NOTIFICATION,
} from './names';


export default [
    {
        path: '/course/boot/trainers',
        name: ROUTE_COURSE_BOOT_TRAINERS,
        component: BootTrainers,
        meta: {
            auth: true,
            title: '新增课程：选择会员',
        },
    },
    {
        path: '/course/boot/trainer/:id(\\d+)',
        name: ROUTE_COURSE_BOOT_TRAINER,
        component: BootTrainer,
        meta: {
            auth: true,
            title: '新增课程',
            bridge: true,
        },
    },
    {
        path: '/course/create',
        component: Create,
        children: [
            {
                path: '',
                name: ROUTE_COURSE_CREATE,
                meta: {
                    auth: true,
                    title: '新增课程',
                },
            },
            {
                path: 'weekdays',
                name: ROUTE_COURSE_CREATE_WEEKDAYS,
                component: Weekdays,
                meta: {
                    auth: true,
                    title: '每周重复',
                },
            },
            {
                path: 'programs',
                name: ROUTE_COURSE_CREATE_PROGRAMS,
                component: Programs,
                meta: {
                    auth: true,
                    title: '锻炼内容',
                },
            },
            {
                path: 'bulking_options',
                name: ROUTE_COURSE_CREATE_BULKING_OPTIONS,
                component: BulkingOptions,
                meta: {
                    auth: true,
                    title: '锻炼内容：增肌',
                },
            },
        ],
    },
    {
        path: '/course/:id(\\d+)',
        component: View,
        children: [
            {
                path: '',
                name: ROUTE_COURSE_VIEW,
                meta: {
                    auth: true,
                    title: '课程详情',
                },
            },
            {
                path: 'weekdays',
                name: ROUTE_COURSE_VIEW_WEEKDAYS,
                component: Weekdays,
                meta: {
                    auth: true,
                    title: '每周重复',
                },
            },
            {
                path: 'programs',
                name: ROUTE_COURSE_VIEW_PROGRAMS,
                component: Programs,
                meta: {
                    auth: true,
                    title: '锻炼内容',
                },
            },
            {
                path: 'bulking_options',
                name: ROUTE_COURSE_VIEW_BULKING_OPTIONS,
                component: BulkingOptions,
                meta: {
                    auth: true,
                    title: '锻炼内容：增肌',
                },
            },
            {
                path: 'editing',
                name: ROUTE_PERIODIC_COURSE_EDITING,
                component: Editing,
                meta: {
                    auth: true,
                    title: '重复课程修改',
                },
            },
            {
                path: 'deleting',
                name: ROUTE_PERIODIC_COURSE_DELETING,
                component: Deleting,
                meta: {
                    auth: true,
                    title: '重复课程删除',
                },
            },
        ],
    },
    {
        path: '/course/:id(\\d+)/notification',
        name: ROUTE_COURSE_NOTIFICATION,
        component: Notification,
        meta: {
            auth: true,
            title: '用户未绑定',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/course.js